module.exports = __webpack_public_path__ + "r-v3/img/ico_no_cam.2f94ee5a.svg";